import { gql } from '@apollo/client/core'

const CUSTOMER_PRICE_LIST_QUERY = gql`
  query customerPriceList($country: String!) {
    customerPriceList {
      id
      deliveryPriceRate
      validFrom
      validTo
      customerTargetRevenue
      insurancePolicy
      referencePriceList
      countries
      priceListItemsByCategories {
        id
        ranges
        priceListItems {
          id
          prices(country: $country) {
            id
            amount
            range
          }
          insurancePrice(country: $country) {
            amount
          }
          categorySegment {
            name
            id
            priceListAnnotation
          }
        }
        category {
          name
          priceListAnnotation
        }
      }
      priceListDeliveryItems {
        label
        discountedMaxPrice
        discountedMinPrice
        composableType
      }
    }
  }
`

export { CUSTOMER_PRICE_LIST_QUERY }
